module.exports = __webpack_public_path__ + "static/media/loginpagebackground.9a4a986d.png";